var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("InputSelect", {
        attrs: {
          label: _vm.titleUF,
          obrigatorio: _vm.ufObrigatorio,
          rulesInput: _vm.ufObrigatorio ? "required" : "",
          opcoes: _vm.estadosBrasileiros,
          nomeAba: _vm.nomeAba,
          widthColumn: _vm.columnSizeUFMunicipio,
          value: _vm.endereco ? _vm.endereco.municipio.codigoEstado : _vm.UF,
          marginLeft: _vm.marginLeftInicio
        },
        on: { input: _vm.updateUF }
      }),
      _vm._v(" "),
      _c("InputSelect", {
        attrs: {
          label: _vm.titleMunicipio,
          obrigatorio: _vm.municipioObrigatorio,
          ufObrigatorio: _vm.municipioObrigatorio ? "required" : "",
          opcoes: _vm.municipiosBrasileiros,
          nomeAba: _vm.nomeAba,
          marginLeft: true,
          widthColumn: _vm.columnSizeUFMunicipio,
          value:
            _vm.endereco && _vm.endereco.municipio
              ? _vm.endereco.municipio.id
              : _vm.municipioId
        },
        on: { input: _vm.updateMunicipio }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec49c7a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec49c7a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/FormulariosProntos/UFMunicipio/UFMunicipio.vue
// module id = null
// module chunks = 